
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPaletteNight as ObiPaletteNightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-palette-night.js';
 
 
 

 
 export const ObiPaletteNight = createComponent({
   react: React,
   tagName: 'obi-palette-night',
   elementClass: ObiPaletteNightElement,
   events: {
     
   }
  });
 
 